import * as React from "react";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { infiniteListPageSize } from "../../../models/common/webConsts";
import { AppUtils } from "source/framework/appUtils";
import * as messageService from "../../../models/services/messageService";
import { List } from "../../framework/List/List";
import { ListSearchFilter } from "source/components/framework/List/ListSearchFilter";
import { ListSearchContainer } from "source/components/framework/List/ListSearchContainer";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { Box, Tooltip } from "@mui/material";
import { IMessageSendEnmailListItem } from "source/models/messageSendEnmail/messageSendEnmailListItem";
import { useEffect } from "react";

interface IMessageSendEmailListProp {
    companyId: string;
    messageId: string;
    height?: string;
}

interface IMessageSendEmailListState {
    // List
    intialized: boolean;
    isLoading: boolean;
    pageSize: number;
    page: number;
    hasMore: boolean;
    filter: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    items: IMessageSendEnmailListItem[];
    selectedId: string;
}

export const MessageSendEmailList = (props: IMessageSendEmailListProp) => {
    const [state, setState] = React.useState<IMessageSendEmailListState>({
        intialized: false,
        isLoading: false,
        page: 1,
        hasMore: true,
        filter: "",
        pageSize: infiniteListPageSize,
        sortColumn: "ModifyDate",
        sortOrderIsAsc: false,
        items: [],
        selectedId: null,
    });

    const searchItems = async (pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean, resetItems: boolean, refreshList: boolean) => {
        setState(old => ({ ...old, isLoading: true }));
        const result = await AppUtils.callService(() => messageService.getMessageSendEnmailListItems(props.companyId, props.messageId, !refreshList ? pageSize : (page * pageSize),
            !refreshList ? page : 1, filter, sortColumn, sortOrderIsAsc), false, true, () => setState(old => ({ ...old, isLoading: false })));
        if (!result) return;
        const items = List.getListItems(state.items, state.selectedId, [], result.items, resetItems, refreshList);
        setState(old => ({
            ...old,
            intialized: true,
            page: !refreshList ? result.page : page,
            hasMore: result.hasMore,
            filter,
            sortColumn,
            sortOrderIsAsc,
            items: items.items,
            selectedId: items.selectedId
        }));
    };

    useEffect(() => {
        searchItems(state.pageSize, state.page, state.filter, state.sortColumn, state.sortOrderIsAsc, true, false);
    }, [props.companyId, props.messageId]);

    const changeFilter = (filter: string) => {
        searchItems(state.pageSize, 1, filter, state.sortColumn, state.sortOrderIsAsc, true, false);
    };

    const handleSearchLines = (sortColumn: string, sortOrderIsAsc: boolean, nextPage: boolean) => {
        searchItems(state.pageSize, !nextPage ? 1 : state.page + 1, state.filter, sortColumn, sortOrderIsAsc, !nextPage, false);
    };

    const handleSetSelectedIds = (selectedId: string, checkedIds: string[]) => {
        setState(old => ({
            ...old,
            selectedId
        }));
    };

    return (
        <>
            <ListSearchContainer sx={{ margin: "0 0 1rem 0" }}>
                <ListSearchFilter
                    searchFilter={state.filter}
                    onSearchClick={changeFilter}
                />
            </ListSearchContainer>
            <List
                intialized={state.intialized}
                isLoading={state.isLoading}
                hasMore={state.hasMore}
                multiSelect={false}
                globalLoadingInUse={false}
                height={props.height}
                header={{
                    columns: [
                        { size: 2, column: "ModifyDate", content: Translations.Time },
                        { size: 4, column: "UserName", content: Translations.User },
                        { size: 3, column: "Email", content: Translations.EmailAddress },
                        { size: 3, column: "UserCompanyName", content: Translations.Company }
                    ]
                }}
                lines={state.items.map((item) => {
                    return {
                        columns: [
                            { size: 2, content: Base.timeToDateTimeStr(item.modifyUser.date) },
                            {
                                size: 4,
                                content: <Box display="flex" sx={{ overflow: "hidden" }}>
                                    <AvatarImage
                                        id={item.modifyUser.code}
                                        name={item.modifyUser.name}
                                        image={item.modifyUser.picture}
                                        tooltip={item.modifyUser.name}
                                    />
                                    <Box display="flex" sx={{ marginLeft: ".5rem", overflow: "hidden" }}>
                                        {item.modifyUser.name}
                                    </Box>
                                    {item.isRead &&
                                        <Tooltip
                                            title={Translations.ReadReceiptGiven}
                                        >
                                            <DoneOutlinedIcon
                                                fontSize="small"
                                                color="info"
                                                sx={{ marginLeft: ".25rem", marginRight: "-0.25rem" }}
                                            />
                                        </Tooltip>
                                    }
                                </Box>
                            },
                            { size: 3, content: item.email },
                            {
                                size: 3,
                                content: <Box display="flex" sx={{ overflow: "hidden" }}>
                                    <AvatarImage
                                        id={item.userCompanyName}
                                        name={item.userCompanyName}
                                        image={item.userCompanyLogo}
                                        tooltip={item.userCompanyName}
                                    />
                                    <Box display="flex" sx={{ marginLeft: ".5rem", overflow: "hidden" }}>
                                        {item.userCompanyName}
                                    </Box>
                                </Box>
                            }
                        ],
                        id: item.id
                    };
                })}
                sortColumn={state.sortColumn}
                sortOrderIsAsc={state.sortOrderIsAsc}
                selectedId={state.selectedId}
                checkedIds={[]}
                onSetSelectedIds={handleSetSelectedIds}
                onSearchLines={handleSearchLines}
                onOpenLine={null}
            />
        </>
    );
};
